import { Api } from "@relode/core";
import { TeamPlanFeaturesResponse, TeamResponse, TeamSuggestRequest } from ".";

export const teamService = {
    getTeamSuggest: async (
        criteria: TeamSuggestRequest,
        signal?: AbortSignal
    ): Promise<TeamResponse[]> => {
        const url = "/teams/suggest";
        const result = await Api.url(url)
            .body({
                ...criteria,
            })
            .retries(3)
            .useSignal(signal)
            .track({ name: "search", data: { criteria } })
            .post<TeamResponse[]>();

        return result;
    },
    getTeamPlanFeatures: async (
        signal?: AbortSignal
    ): Promise<TeamPlanFeaturesResponse> => {
        const url = "/teamplan/feature";
        const result = await Api.url(url)
            .retries(3)
            .useSignal(signal)
            .track({ name: "get team plan features" })
            .get<TeamPlanFeaturesResponse>();

        return result;
    },
};
